import style from "./../precision.module.css";
import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";
import { useTranslation } from "react-i18next";

const TruePositivesChart = () => {
    const { t } = useTranslation("landing-page");
    
    const [ref, inView] = useInView({
        threshold: 0.5,
        triggerOnce: true,
    });

    // Animations for the correct bar
    const truePositiveBarHigherAnimation = useSpring({
        height: inView ? "140px" : "0px",
        from: { height: "0px" },
        config: { mass: 1, tension: 280, friction: 60 },
        delay: 300,
    });

    const truePositiveBarLowerAnimation = useSpring({
        height: inView ? "120px" : "0px",
        from: { height: "0px" },
        config: { mass: 1, tension: 280, friction: 60 },
        delay: 300,
    });

    // Animation for the wrong bar
    const wrongBarHigherAnimation = useSpring({
        height: inView ? "80px" : "0px",
        from: { height: "0px" },
        config: { mass: 1, tension: 280, friction: 60 },
        delay: 400,
    });

    const wrongBarLowerAnimation = useSpring({
        height: inView ? "60px" : "0px",
        from: { height: "0px" },
        config: { mass: 1, tension: 280, friction: 60 },
        delay: 400,
    });

    // Animation for x-axis
    const xAxisAnimation = useSpring({
        width: inView ? "355px" : "0px",
        from: { width: "0px" },
        config: { mass: 1, tension: 280, friction: 60 },
        delay: 100,
    });

    // Animation for y-axis
    const yAxisAnimation = useSpring({
        height: inView ? "200px" : "0px",
        from: { height: "0px" },
        config: { mass: 1, tension: 280, friction: 60 },
        delay: 100,
    });

    return (
        <div ref={ref}>
            <div className={style.graphWrapper}>
                <p className={style.graphTitle}>{t("true_positives_chart.title")}</p>

                <animated.div className={style.yAxis} style={yAxisAnimation} />
                <animated.div className={style.xAxis} style={xAxisAnimation} />

                <animated.div className={style.truePositiveBarHigher} style={truePositiveBarHigherAnimation} />
                <animated.div className={style.truePositiveBarLower} style={truePositiveBarLowerAnimation} />

                <animated.div className={style.falseNegativeHigherBar} style={wrongBarHigherAnimation} />
                <animated.div className={style.falseNegativeLowerBar} style={wrongBarLowerAnimation} />

                <p className={style.labelCorrect}>{t("true_positives_chart.recognized_as_ai")}</p>
                <p className={style.labelWrong}>{t("true_positives_chart.uncertain_or_not_recognized")}</p>
            </div>
        </div>
    );
};

export default TruePositivesChart;
